import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-pop-out"
export default class extends Controller {
  connect() {
    const button = document.querySelector('input#exercise-session-form-button');
    if (button) {
      button.addEventListener('click', function() {
        const form = document.querySelector('form#exercise-session-form');
        form.target = 'exerciseSessionForm';
        window.open('', 'exerciseSessionForm', 'width=800,height=1200,toolbar=0,scrollbars=1');
        form.submit();
      });
    }
  }

  close(event) {
    window.close('exerciseSessionForm');
  }
}
